import { getAuth, sendPasswordResetEmail, EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';

// Email a Firebase password-reset link (default template).
export async function sendReset(email) {
  return sendPasswordResetEmail(getAuth(), email);
}

// Re-authenticate with the current password, then set a new one.
export async function changePassword({ currentPassword, newPassword }) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user || !user.email) throw new Error('not-signed-in');
  await reauthenticateWithCredential(user, EmailAuthProvider.credential(user.email, currentPassword));
  await updatePassword(user, newPassword);
}
